import { render, staticRenderFns } from "./JobSearch.vue?vue&type=template&id=3967488b&scoped=true&"
import script from "./JobSearch.vue?vue&type=script&lang=js&"
export * from "./JobSearch.vue?vue&type=script&lang=js&"
import style0 from "./JobSearch.vue?vue&type=style&index=0&id=3967488b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967488b",
  null
  
)

export default component.exports